import { useSyncExternalStore } from 'react';
import { StoredMarketsLastVisitedAt } from '@/shared/utils/Stored';
import { MARKETS_LAST_VISITED_AT } from '@/shared/utils/Stored/KEYS';

const listeners = new Set<() => void>();

// Another tab visiting /markets must clear this tab's "new markets" count
// too — hence the storage listener; a `null` key is a whole-storage clear.
function subscribe(cb: () => void) {
  listeners.add(cb);
  const onStorage = (e: StorageEvent) => {
    if (e.key === MARKETS_LAST_VISITED_AT || e.key === null) cb();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(cb);
    window.removeEventListener('storage', onStorage);
  };
}

function getSnapshot() {
  return StoredMarketsLastVisitedAt.get();
}

export function useLastVisitedMarketsAt(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function setLastVisitedMarketsAt(value: string) {
  StoredMarketsLastVisitedAt.set(value);
  listeners.forEach((cb) => cb());
}
